import type { InvitedAppShortcutsRecommendationsQuery$variables } from './__generated__/InvitedAppShortcutsRecommendationsQuery.graphql.ts';

/**
 * Single source of truth for the Invited App Shortcuts GRS recommendations query variables, shared
 * by the SSR preloader (`preloadInvitedAppShortcutsRecommendationsQuery`) and the render-time
 * consumer (`InvitedAppShortcutsRecommendations`).
 *
 * These MUST be identical between preload and consume, otherwise the client's `store-or-network`
 * lookup misses the SSR-seeded record and refetches. Keeping one builder (typed to the generated
 * query's `$variables`) makes that invariant structural rather than a comment.
 *
 * Confluence's rerank candidate is `jira` (the cross-product target) — the reverse of Jira's value.
 */
export const buildInvitedAppShortcutsRecommendationsVariables = (
	cloudId: string,
): InvitedAppShortcutsRecommendationsQuery$variables => ({
	tenantId: cloudId,
	product: 'confluence',
	rerank: [{ entityId: 'jira' }],
});
